import { render, staticRenderFns } from "./LastModified.vue?vue&type=template&id=137ecff6&scoped=true&"
import script from "./LastModified.vue?vue&type=script&lang=js&"
export * from "./LastModified.vue?vue&type=script&lang=js&"
import style0 from "./LastModified.vue?vue&type=style&index=0&id=137ecff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137ecff6",
  null
  
)

export default component.exports